import _classCallCheck from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { MangoAgent } from "../api";
import { BaseResource } from "@kgsport-cms/common";
import "../common";
export var MangoAgentService = /*#__PURE__*/function (_BaseResource) {
  _inherits(MangoAgentService, _BaseResource);
  var _super = _createSuper(MangoAgentService);
  function MangoAgentService() {
    _classCallCheck(this, MangoAgentService);
    return _super.apply(this, arguments);
  }
  _createClass(MangoAgentService, [{
    key: "getSpreadLink",
    value:
    // 获取邀请链接
    function getSpreadLink(params) {
      return this.requester.get(MangoAgent.getSpreadLink, {
        params
      });
    }
    // 获取即时报表和邀请配置
  }, {
    key: "getReport",
    value: function getReport(params) {
      return this.requester.get(MangoAgent.getReport, {
        params
      });
    }
    // 获取已付佣金
  }, {
    key: "getPayCommission",
    value: function getPayCommission(params) {
      return this.requester.get(MangoAgent.getPayCommission, {
        params
      });
    }
    // 获取下线统计报表
  }, {
    key: "getLowerStatis",
    value: function getLowerStatis(params) {
      return this.requester.get(MangoAgent.getLowerStatis, {
        params
      });
    }
    // 薪水 工资记录
  }, {
    key: "getSalary",
    value: function getSalary(params) {
      return this.requester.get(MangoAgent.getSalary, {
        params
      });
    }
    // 受邀人 下线用户报表
  }, {
    key: "getInviteRecord",
    value: function getInviteRecord(params) {
      return this.requester.get(MangoAgent.getInviteRecord, {
        params
      });
    }
    // 奖金 个人奖金列表
  }, {
    key: "getCommissionRecord",
    value: function getCommissionRecord(params) {
      return this.requester.get(MangoAgent.getCommissionRecord, {
        params
      });
    }
  }]);
  return MangoAgentService;
}(BaseResource);